export const sliceWhen =
  <T>(function_: (a: T, b: T) => boolean) =>
  (xs: T[]): T[][] => {
    if (xs.length === 0) {
      return []
    }
    if (xs.length === 1) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return [[xs[0]!]]
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion,sonarjs/todo-tag
    const result: T[][] = [[xs[0] as T]] // TODO
    // eslint-disable-next-line no-plusplus
    for (let index = 1; index < xs.length; index++) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const x = xs[index]!
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const previousGroup = result.at(-1)!
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const previousValue = previousGroup.at(-1)!
      if (function_(previousValue, x)) {
        // 新しいグループとしてpush
        result.push([x])
      } else {
        previousGroup.push(x)
      }
    }
    return result
  }

export const mapConsIncremental = <A>(as: A[]): A[][] => {
  const xs = as.reduce<A[][]>((accumulator, x) => {
    const lastXs = accumulator.at(-1) ?? []
    const newXs = [...lastXs, x]
    return [...accumulator, newXs]
  }, [])
  return xs
}

function sortBy<T>(xs: T[], f: (x: T) => number) {
  return [...xs].sort((a, b) => {
    const aKey = f(a)
    const bKey = f(b)
    // eslint-disable-next-line sonarjs/no-nested-conditional
    return aKey - bKey < 0 ? -1 : aKey === bKey ? 0 : 1
  })
}

// mapperの返り値の順番で要素をソートする。
// mapperがundefinedを返す場合は、その要素の位置は固定される
export function sortSpecificElementOnly<T>(xs: T[], mapper: (x: T) => number | undefined): T[] {
  const fixed = xs.filter((x) => mapper(x) === undefined)
  const toBeSorted = xs.filter((x) => mapper(x) !== undefined)
  const sorted = sortBy(toBeSorted, (x) => mapper(x) ?? 0)

  return xs.map((_, index) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const isFixed = mapper(xs[index]!) === undefined
    if (isFixed) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return fixed.shift()!
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return sorted.shift()!
  })
}

export function unique<T>(xs: T[]): T[] {
  return [...new Set(xs)]
}

export const upsertBy = function <T extends Record<string, unknown>>(xs: T[], y: T, f: (x: T) => string): T[] {
  const index = xs.findIndex((x) => f(y) === f(x))
  if (index === -1) {
    return [...xs, y]
  }
  return [...xs.slice(0, index), y, ...xs.slice(index + 1)]
}

// oldの位置にある要素を、newの位置に入れ替える
export const move = function <T>(as: T[], oldIndex: number, newIndex: number): T[] {
  const xs = [...as]
  const x = xs[oldIndex]
  if (x === undefined) {
    return as
  }
  xs.splice(oldIndex, 1)
  xs.splice(newIndex, 0, x)

  return xs
}
